import { render, staticRenderFns } from "./MultiOrderableDocumentKindListSelector.vue?vue&type=template&id=d2a85468&scoped=true&"
import script from "./MultiOrderableDocumentKindListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiOrderableDocumentKindListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiOrderableDocumentKindListSelector.vue?vue&type=style&index=0&id=d2a85468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a85468",
  null
  
)

export default component.exports